export const COMPANY = {
  name: 'SKycodeX AgroTech',
  tagline: 'TRUST IS OUR BUSINESS',
  email: 'agrotech@skycodex.in',
  phone: '+91 7066054494',
  phoneRaw: '+917066054494',
  website: 'agrotech.skycodex.in',
  location: 'Pune, Maharashtra, India – 412105',
  whatsapp:
    'https://wa.me/917066054494?text=' +
    encodeURIComponent(
      'Hello SKycodeX AgroTech, I am interested in your agricultural products and would like to discuss an enquiry.'
    ),
};

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Products', href: '#products' },
  { label: 'Quality', href: '#quality' },
  { label: 'Contact', href: '#contact' },
];

export const PRODUCT_OPTIONS = [
  'Red Onion Flakes',
  'White Onion Flakes',
  'Red Onion Powder',
  'White Onion Powder',
  'Other Agricultural Products',
];

export const PRODUCTS = [
  {
    id: 'red-onion-flakes',
    name: 'Red Onion Flakes',
    short:
      'Dehydrated red onion flakes with rich aroma and natural deep colour, prepared for food processing and seasoning applications.',
    image:
      'https://images.unsplash.com/photo-1742845794669-3ff1b66b8483?w=1200&q=80&auto=format&fit=crop',
    alt: 'Finely chopped red onions prepared for dehydration',
    description:
      'Red onion flakes produced from carefully sourced Indian red onions, dehydrated and prepared for export-oriented supply. Suitable for food processing, seasonings, ready meals and culinary applications.',
    form: 'Dehydrated flakes / kibbled',
    colour: 'Natural deep red to pinkish tone characteristic of red onion',
    cut: 'Standard export cuts available. Typical cut / particle size can be discussed based on buyer requirements.',
    moisture: 'Controlled to export-appropriate levels. Final moisture specification as per buyer PO and batch COA.',
    packing: 'Export-grade poly-lined cartons or bags. Bulk and buyer-specific packing options available on request.',
    quality: 'Carefully sourced, cleaned and sorted. Product quality is evaluated according to buyer requirements and applicable specifications.',
    coa: 'COA available for applicable batches.',
    docs: 'Export documentation prepared according to transaction and destination requirements.',
  },
  {
    id: 'white-onion-flakes',
    name: 'White Onion Flakes',
    short:
      'Clean, uniformly cut dehydrated white onion flakes suited to soups, sauces, ready meals and food manufacturing.',
    image:
      'https://images.unsplash.com/photo-1587735243474-5426387356db?w=1200&q=80&auto=format&fit=crop',
    alt: 'Fresh white onion on a clean light background',
    description:
      'White onion flakes prepared from quality Indian white onions with a clean, natural profile. A versatile ingredient for food processors, seasoning blends and industrial kitchens.',
    form: 'Dehydrated flakes / kibbled',
    colour: 'Natural white to off-white tone',
    cut: 'Standard export cuts available. Typical cut / particle size can be discussed based on buyer requirements.',
    moisture: 'Controlled to export-appropriate levels. Final moisture specification as per buyer PO and batch COA.',
    packing: 'Export-grade poly-lined cartons or bags. Bulk and buyer-specific packing options available on request.',
    quality: 'Carefully sourced, cleaned and sorted. Product quality is evaluated according to buyer requirements and applicable specifications.',
    coa: 'COA available for applicable batches.',
    docs: 'Export documentation prepared according to transaction and destination requirements.',
  },
  {
    id: 'red-onion-powder',
    name: 'Red Onion Powder',
    short:
      'Finely milled red onion powder with a full savoury profile, ideal for spice blends, seasonings and food applications.',
    image:
      'https://images.unsplash.com/photo-1595414902678-862fe51c9f27?w=1200&q=80&auto=format&fit=crop',
    alt: 'Fine reddish-brown onion powder',
    description:
      'Red onion powder milled from dehydrated red onion, delivering concentrated flavour for spice blends, snacks, sauces and processed food applications.',
    form: 'Dehydrated milled powder',
    colour: 'Natural reddish-pink to brownish tone',
    cut: 'Standard mesh sizes available. Particle size can be discussed based on buyer requirements.',
    moisture: 'Controlled to export-appropriate levels. Final moisture specification as per buyer PO and batch COA.',
    packing: 'Moisture-protective export packing in poly-lined bags or cartons. Buyer-specific packing available on request.',
    quality: 'Carefully sourced, cleaned and sorted. Product quality is evaluated according to buyer requirements and applicable specifications.',
    coa: 'COA available for applicable batches.',
    docs: 'Export documentation prepared according to transaction and destination requirements.',
  },
  {
    id: 'white-onion-powder',
    name: 'White Onion Powder',
    short:
      'Smooth white onion powder delivering consistent flavour for sauces, snacks, seasonings and food formulations.',
    image:
      'https://images.unsplash.com/photo-1586137712370-9b450509c587?w=1200&q=80&auto=format&fit=crop',
    alt: 'Fine white onion powder in a dark bowl',
    description:
      'White onion powder milled from dehydrated white onion for consistent, easy-to-use flavour in food manufacturing, sauces, marinades and seasoning systems.',
    form: 'Dehydrated milled powder',
    colour: 'Natural cream to light ivory tone',
    cut: 'Standard mesh sizes available. Particle size can be discussed based on buyer requirements.',
    moisture: 'Controlled to export-appropriate levels. Final moisture specification as per buyer PO and batch COA.',
    packing: 'Moisture-protective export packing in poly-lined bags or cartons. Buyer-specific packing available on request.',
    quality: 'Carefully sourced, cleaned and sorted. Product quality is evaluated according to buyer requirements and applicable specifications.',
    coa: 'COA available for applicable batches.',
    docs: 'Export documentation prepared according to transaction and destination requirements.',
  },
];

export const IMAGES = {
  heroMain:
    'https://images.unsplash.com/photo-1518977956812-cd3dbadaaf31?w=1600&q=80&auto=format&fit=crop',
  heroCard:
    'https://images.pexels.com/photos/7333168/pexels-photo-7333168.jpeg?auto=compress&cs=tinysrgb&w=600',
  aboutMain:
    'https://images.unsplash.com/photo-1558458654-a145c979a342?w=1200&q=80&auto=format&fit=crop',
  aboutField:
    'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=900&q=80&auto=format&fit=crop',
  qualityLab:
    'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=1000&q=80&auto=format&fit=crop',
  qualityDocs:
    'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1000&q=80&auto=format&fit=crop',
  cargo:
    'https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?w=1600&q=80&auto=format&fit=crop',
  agroTech:
    'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1200&q=80&auto=format&fit=crop',
};
